<template>
  <div class="info-up-box">
    <div class="text1 fw600 mb30 flex flex-between">
      <div>
        {{ showIndex === 1 ? "报名信息" : "资料上传" }}
      </div>
      <div @click="$router.push({ name: 'szMicroClass' })">
        <img
          style="width: 30px; height: 30px; cursor: pointer"
          src="~@/assets/images/img59.png"
          alt=""
          title="返回"
        />
      </div>
    </div>
    <step-view :showIndex="showIndex"></step-view>
    <div v-if="showIndex === 1">
      <step1
        @goStep="goStep"
        ref="step1"
        :editInfoStep1="editInfoStep1"
      ></step1>
    </div>
    <div v-if="showIndex === 2">
      <step2
        :loadList="loadList1"
        :oldApplyFiles1="oldApplyFiles1"
        @downStep="downStep"
        @upStep="upStep"
        @deleteFile="deleteFile"
        @upDataFile="upDataFile"
      ></step2>
    </div>
    <div v-if="showIndex === 3">
    <a-spin :spinning="spinning">
      <step3
        :loadList="loadList2"
        :oldApplyFiles2="oldApplyFiles2"
        @deleteFile2="deleteFile2"
        @submit="submit"
        @upStep2="upStep2"
        @upDataFile="upDataFile"
      ></step3>
      </a-spin>
    </div>
  </div>
</template>

<script>
import stepView from "./stepView.vue";
import step1 from "./step1.vue";
import step2 from "./step2.vue";
import step3 from "./step3.vue";
import { lxApplySaveOrUpdate, deleteFile } from "../../api/index";
import { pieviewURL } from "../../utils/request";
export default {
  name: "",
  components: { stepView, step1, step2, step3 },
  props: {
    editInfo: { type: Object, default: null },
  },
  data() {
    return {
      showIndex: 1,
      step1: null,
      step2: {},
      step3: {},
      oldApplyFiles1: [],
      spinning:false,
      oldApplyFiles2: [],
      loadList1: [
        {
          title: "本校“三个一工程”工作方案上传",
          id: 1,
          remarks: "注：请上传pdf格式的文件，文件大小不超过100m",
          accept: ".pdf",
          icon: require("../../assets/images/img24.png"),
          fileList: [],
          oldFileList: [],
          loading: false,
        },
        {
          title: "校级立项相关文件上传",
          id: 2,
          remarks: "注：请上传pdf格式的文件，文件大小不超过100m",
          accept: ".pdf",
          icon: require("../../assets/images/img30.png"),
          fileList: [],
          oldFileList: [],
          loading: false,
        },
        {
          title: "专项资金经费支持相关文件上传",
          id: 3,
          remarks: "注：请上传pdf格式的文件，文件大小不超过100m",
          accept: ".pdf",
          icon: require("../../assets/images/img31.png"),
          fileList: [],
          oldFileList: [],
          loading: false,
        },
      ],
      loadList2: [
        {
          title: "思政微课申报书上传",
          id: 4,
          remarks: "注：请上传pdf格式的文件，文件大小不超过100m",
          accept: ".pdf",
          icon: require("../../assets/images/img27.png"),
          fileList: [],
          oldFileList: [],
          loading: false,
        },
        {
          title: "微课视频",
          id: 5,
          remarks: "", //注：时常5-10分钟，分辨率不低于720p，视频大小小于500M
          accept: ".mp4",
          icon: require("../../assets/images/img40.png"),
          fileList: [],
          oldFileList: [],
          loading: false,
        },
        {
          title: "佐证材料",
          id: 6,
          remarks: "",
          accept: "",
          icon: require("../../assets/images/img29.png"),
          fileList: [],
          oldFileList: [],
          loading: false,
        },
      ],
      editInfoStep1: {},
      id: null,
    };
  },
  computed: {},
  watch: {},
  created() {},
  destroyed() {
    window.sessionStorage.removeItem(`step${this.$store.state.user.id}`);
  },
  mounted() {
    if (this.editInfo !== null) {
      this.id = this.editInfo.id;
      // this.editInfoStep1.name = this.editInfo.name;
      // this.editInfoStep1.principals = this.editInfo.principals;
      // this.editInfoStep1.phone = this.editInfo.phone;
      // this.editInfoStep1.courseType = this.editInfo.courseType;
      this.$refs.step1.info = this.editInfo;
      for (let i = 0; i < this.loadList1.length; i++) {
        this.editInfo.applyFiles.map((item1) => {
          if (this.loadList1[i].id == item1.fileType) {
            let newItem = {};
            let newApplyFiles = {};
            newApplyFiles.filePath = item1.filePath;
            newApplyFiles.fileType = item1.fileType;
            newItem.uid = item1.id;
            newItem.fileType = item1.fileType;
            let newName = item1.filePath.slice(
              item1.filePath.lastIndexOf("/") + 1
            );
            let firstname = newName.slice(0, newName.lastIndexOf("_"));
            let lastname = newName.slice(newName.lastIndexOf("."));
            newItem.name = firstname + lastname;
            newItem.name1 = newName;
            newItem.url = pieviewURL + newName;
            this.loadList1[i].fileList.push(newItem);
            this.oldApplyFiles1.push(newApplyFiles);
          }
        });
      }
      for (let i = 0; i < this.loadList2.length; i++) {
        this.editInfo.applyFiles.map((item1) => {
          if (this.loadList2[i].id == item1.fileType) {
            let newItem = {};
            let newApplyFiles = {};
            newApplyFiles.filePath = item1.filePath;
            newApplyFiles.fileType = item1.fileType;
            newItem.uid = item1.id;
            let newName = item1.filePath.slice(
              item1.filePath.lastIndexOf("/") + 1
            );
            let firstname = newName.slice(0, newName.lastIndexOf("_"));
            let lastname = newName.slice(newName.lastIndexOf("."));
            newItem.name = firstname + lastname;
            newItem.name1 = newName;
            newItem.url = pieviewURL + newName;
            newItem.fileType = item1.fileType;
            this.loadList2[i].fileList.push(newItem);
            this.oldApplyFiles2.push(newApplyFiles);
          }
        });
      }
    }
  },
  methods: {
    goStep(item) {
      this.showIndex = 2;
      this.step1 = item;
    },
    //上传文件更新
    upDataFile(fileItem, index, type) {
      if (type === 1) {
        let newItem = {};
        newItem.fileType = fileItem.fileType;
        let newName = fileItem.filePath.slice(
          fileItem.filePath.lastIndexOf("/") + 1
        );
        let firstname = newName.slice(0, newName.lastIndexOf("_"));
        let lastname = newName.slice(newName.lastIndexOf("."));
        newItem.name = firstname + lastname;
        newItem.name1 = newName;
        newItem.url = pieviewURL + newName;
        newItem.uid = fileItem.uid;
        this.loadList1[index].fileList.push(newItem);
      } else {
        let newItem = {};
        newItem.fileType = fileItem.fileType;
        let newName = fileItem.filePath.slice(
          fileItem.filePath.lastIndexOf("/") + 1
        );
        let firstname = newName.slice(0, newName.lastIndexOf("_"));
        let lastname = newName.slice(newName.lastIndexOf("."));
        newItem.name = firstname + lastname;
        newItem.name1 = newName;
        newItem.url = pieviewURL + newName;
        newItem.uid = fileItem.uid;
        this.loadList2[index].fileList.push(newItem);
      }
    },
    uploadInfo(info) {
      this.loadList1 = info;
    },
    upStep(stepTwoList2, stepTwoList3) {
      this.showIndex = 1;
      this.step2 = stepTwoList3;
      this.oldApplyFiles1 = stepTwoList3;
      this.loadList1 = stepTwoList2;
    },
    upStep2(stepTwoList3, stepTwoList4) {
      this.showIndex = 2;
      this.step3 = stepTwoList4;
      this.oldApplyFiles2 = stepTwoList4;
      this.loadList2 = stepTwoList3;
    },
    deleteFile(file) {
      deleteFile({
        filePath: `linxuan/${file.name1}`,
      }).then((res) => {
        if (res.code === 200) {
          this.$message.success(res.message);
        }
      });
      this.oldApplyFiles1 = this.oldApplyFiles1.filter((item) => {
        if (item.filePath.indexOf(file.name1) === -1) {
          return item;
        }
      });
    },
    deleteFile2(file) {
      deleteFile({
        filePath: `linxuan/${file.name1}`,
      }).then((res) => {
        if (res.code === 200) {
          this.$message.success(res.message);
        }
      });
      this.oldApplyFiles2 = this.oldApplyFiles2.filter((item) => {
        if (item.filePath.indexOf(file.name1) === -1) {
          return item;
        }
      });
    },
    downStep(stepTwoList, stepTwoList2) {
      this.showIndex = 3;
      this.step2 = stepTwoList2;
      this.oldApplyFiles1 = stepTwoList2;
      this.loadList1 = stepTwoList;
    },
    submit(List, applyFiles2) {
      let data = {};
      this.spinning = true
      this.step3 = applyFiles2;
      let applyFiles = this.step2.concat(this.step3);
      data.applyFiles = applyFiles;
      data.name = this.step1.name;
      data.phone = this.step1.phone;
      data.principals = this.step1.principals;
      data.schoolName = this.$store.state.user.realname;
      data.courseType = this.step1.courseType;
      data.teamType = this.step1.teamType;
      let routerPath = "";
      if (this.$route.name === "szStudioDataUpload") {
        data.applyType = 1;
        routerPath = "szStudio";
      } else if (this.$route.name === "educationalBrandDataUpload") {
        data.applyType = 2;
        routerPath = "educationalBrand";
      } else {
        data.applyType = 3;
        routerPath = "szMicroClass";
      }
      if (this.id !== null) {
        data.id = this.id;
      }
      this.addLxApplySaveOrUpdate(data, routerPath);
    },
    addLxApplySaveOrUpdate(data, routerPath) {
      lxApplySaveOrUpdate(data).then((res) => {
        if (res.code === 200) {
          this.$message.success(res.message);
          this.spinning = false
          this.$router.push({ name: routerPath });
          window.sessionStorage.removeItem(`step${this.$store.state.user.id}`);
        } else {
          this.$message.error(res.message);
          this.spinning = false
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.info-up-box {
  width: 100%;
  height: 100%;
  // max-height: 645px;
  overflow-y: auto;
  padding: 15px 30px;
  background: #ffffff;
  border-radius: 10px;
}
.text1 {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}
.text2 {
  font-size: 13px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  margin-top: 14px;
  margin-bottom: 15px;
}
.mb30 {
  margin-bottom: 20px;
}
.fw600 {
  font-weight: 600;
}
.img-box {
  width: 50px;
  height: 50px;
  cursor: pointer;
  margin-bottom: 16px;
}
.img-box-2 {
  width: 19px;
  height: 19px;
  margin-right: 10px;
}
.img-box-3 {
  width: 241px;
  height: 203px;
  margin: 50px auto;
}
.img-box-4 {
  width: 12px;
  height: 12px;
  margin-right: 10px;
  margin-bottom: 5px;
}
.step-box {
  padding-bottom: 10px;
}
.submit-btn {
  width: 116px;
  height: 40px;
  margin: 0 auto;
  line-height: 38px;
  text-align: center;
  background: #c73630;
  border-radius: 10px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  cursor: pointer;
}
</style>
